import React, { useEffect, useRef, useState } from "react";
import { FormGroup, Label } from "reactstrap";
import Select from "react-select";

const agentNameTypeaheadStyles = {
	container: (base) => ({
		...base,
		width: "100%",
	}),
	control: (base, state) => ({
		...base,
		minHeight: 34,
		height: 34,
		borderColor: state.isFocused ? "#80bdff" : base.borderColor,
		boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)" : "none",
	}),
	valueContainer: (base) => ({
		...base,
		height: 32,
		padding: "0 6px",
	}),
	indicatorsContainer: (base) => ({
		...base,
		height: 32,
	}),
	input: (base) => ({
		...base,
		margin: 0,
		padding: 0,
	}),
	placeholder: (base) => ({
		...base,
		margin: 0,
	}),
	singleValue: (base) => ({
		...base,
		margin: 0,
	}),
};

export default function AgentNameTypeahead({
	value,
	options,
	onSearch,
	onChange,
	placeholder = "Enter Agent Name",
}) {
	const searchTimerRef = useRef(null);
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	useEffect(() => {
		return () => {
			if (searchTimerRef.current) {
				clearTimeout(searchTimerRef.current);
			}
		};
	}, []);

	return (
		<FormGroup style={{ minHeight: isMenuOpen ? 250 : undefined }}>
			<Label for="agentName">Agent Name</Label>
			<Select
				inputId="agentName"
				name="agentName"
				placeholder={placeholder}
				styles={agentNameTypeaheadStyles}
				value={value}
				options={options}
				isClearable
				maxMenuHeight={190}
				noOptionsMessage={() => "No matching agents"}
				onMenuOpen={() => setIsMenuOpen(true)}
				onMenuClose={() => setIsMenuOpen(false)}
				onInputChange={(inputValue, meta) => {
					if (meta?.action !== "input-change") {
						return;
					}
					if (searchTimerRef.current) {
						clearTimeout(searchTimerRef.current);
					}
					const keyword = (inputValue || "").trim();
					if (keyword.length < 2) {
						onSearch("");
						return;
					}
					searchTimerRef.current = setTimeout(() => {
						onSearch(keyword);
					}, 300);
				}}
				onChange={onChange}
			/>
		</FormGroup>
	);
}
